module.exports = __webpack_public_path__ + "static/media/12UNCTAD11.d584cd00.jpg";